import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const WinIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 52,
  height = 52,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <defs>
        <polygon id="campaigns-petition-win" points="0 0 9.3168 0 9.3168 7.89403633 0 7.89403633" />
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g id="win">
          <path
            d="M0,15 C0,23.284 6.716,30 15,30 C23.284,30 30,23.284 30,15 C30,6.716 23.284,0 15,0 C6.716,0 0,6.716 0,15"
            fill="#EB9500"
            id="Fill-1"
          ></path>
          <path
            d="M8.5761,8.0676 C8.5761,14.2936 11.3981,19.3416 14.8801,19.3416 C18.3621,19.3416 21.1841,14.2936 21.1841,8.0676 L8.5761,8.0676 Z"
            fill="#ffffff"
            className={styles.white}
            id="Fill-3"
          ></path>
          <path
            d="M13.3618,16.9486 C13.3618,16.9486 14.2358,21.8726 11.1528,22.9306 L11.1528,24.3576 L18.6538,24.3576 L18.6538,23.1606 C18.6538,23.1606 15.4528,21.8536 16.1908,17.2746 C16.1988,17.2276 16.2068,17.1806 16.2148,17.1326 C17.0428,12.4386 13.3618,16.9486 13.3618,16.9486"
            fill="#ffffff"
            className={styles.white}
            id="Fill-5"
          ></path>
          <polygon
            fill="#EB9500"
            id="Fill-7"
            points="14.8573 9.5834 15.8883 11.6724 18.1933 12.0074 16.5253 13.6334 16.9193 15.9294 14.8573 14.8454 12.7953 15.9294 13.1893 13.6334 11.5213 12.0074 13.8263 11.6724"
          ></polygon>
          <path
            d="M19.1598,9.8162 L23.7618,9.8162 C23.7618,9.8162 22.9328,15.7982 17.1808,16.5802"
            id="Stroke-9"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinejoin="round"
          ></path>
          <path
            d="M10.969,9.8162 L6.367,9.8162 C6.367,9.8162 7.196,15.7982 12.948,16.5802"
            id="Stroke-11"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinejoin="round"
          ></path>
        </g>
      </g>
    </Icon>
  )
}
